import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { TenantDashboardComponent } from './tenant-dashboard.component';
import { TenantDashboardRoutingModule } from './tenant-dashboard-routing.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {MyServicesModule} from '../service/my-services/my-services.module';
import {IconsModule} from '../../icons/icons.module';
import {CircleProgressBarModule} from '../../components/circle-progress-bar/circle-progress-bar.module';
import {TicketsModule} from '../../components/tickets/tickets.module';
import { MatSelectModule } from '@angular/material/select';
import { TableModule } from 'src/app/table/table.module';
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatDividerModule } from '@angular/material/divider';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ViewInstanceDetailsComponent } from './view-instance-details/view-instance-details.component';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { MatCardModule } from '@angular/material/card';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { JumpboxMessageComponent } from 'src/app/components/toastr-templates/jumpbox-message/jumpbox-message.component';
import { CalendarModule } from 'angular-calendar';
import { ScheduleDetailsComponent } from './schedule-details/schedule-details.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TitleCasePipe } from '@angular/common';
@NgModule({
  declarations: [
    TenantDashboardComponent,
    ViewInstanceDetailsComponent,
    JumpboxMessageComponent,
    ScheduleDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    TenantDashboardRoutingModule,
    MyServicesModule,
    IconsModule,
    CircleProgressBarModule,
    TicketsModule,
    MatSelectModule,
    TableModule,
    ToolbarModule,
    MatProgressSpinnerModule,
    NgxSkeletonLoaderModule,
    BreadcrumbModule,
    MatCardModule,
    SatPopoverModule,
    MatDialogModule,
    CalendarModule,
    NgxEchartsModule.forRoot({
      echarts
    }),
  ],
  providers: [TitleCasePipe]
})
export class TenantDashboardModule {
}

